import React from 'react';
import { Button, Form, Input, Label } from '../../components/Bootstrap';
import { TopBarDatePicker } from '../../components/TopBarDatePicker';
import { OrdersListQuery_fulfillmentCenters as FulfillmentCenter } from './__generated__/OrdersListQuery';
export type OrderFilters = {
  start: Date;
  end: Date;
  fulfillmentCenterId?: string;
  orderNumber?: string;
  orderId?: string;
};

type OrderFilterProps = {
  values: OrderFilters;
  fulfillmentCenters: FulfillmentCenter[];
  onUpdateFilters(filters: OrderFilters);
};

export const OrderFilter: React.FC<OrderFilterProps> = ({ onUpdateFilters, values, fulfillmentCenters }) => {
  const [start, setStart] = React.useState(values.start);
  const [end, setEnd] = React.useState(values.end);
  const [orderNumber, setOrderNumber] = React.useState(values.orderNumber ?? '');
  const [fulfillmentCenterId, setFulfillmentCenterId] = React.useState(values.fulfillmentCenterId);
  const [orderId, setOrderId] = React.useState(values.orderId ?? '');

  const resetValues = React.useCallback(() => {
    setStart(values.start);
    setEnd(values.end);
    setOrderNumber(values.orderNumber ?? '');
    setOrderId(values.orderId ?? '');
    setFulfillmentCenterId(values.fulfillmentCenterId);
  }, [values, setStart, setEnd, setOrderId, setOrderNumber, setFulfillmentCenterId]);

  const isChanged = React.useMemo(() => {
    return (
      start != values.start ||
      end != values.end ||
      fulfillmentCenterId != values.fulfillmentCenterId ||
      orderNumber != (values.orderNumber ?? '') ||
      orderId != (values.orderId ?? '')
    );
  }, [start, end, fulfillmentCenterId, orderNumber, orderId, values]);

  React.useEffect(() => {
    resetValues();
  }, [resetValues]);

  const onSubmit = React.useCallback(
    (e) => {
      e.preventDefault();
      onUpdateFilters({
        start,
        end,
        fulfillmentCenterId: fulfillmentCenterId ? fulfillmentCenterId : undefined,
        orderNumber: orderNumber ? orderNumber : undefined,
        orderId: orderId ? orderId : undefined,
      });
    },
    [onUpdateFilters, start, end, fulfillmentCenterId, orderNumber, orderId]
  );

  const onChangeFulfillmentCenter = (e) => {
    const value = e.target.value == 'Select Fulfillment ID' ? undefined : e.target.value;
    setFulfillmentCenterId(value);
  };

  const onChangeDate = (newStart, newEnd) => {
    setStart(newStart);
    setEnd(newEnd);
  };

  return (
    <Form onSubmit={onSubmit} className='user-management-modal-form mb-3'>
      <div className='row gap-2'>
        <div className='col-2 form-group mb-0'>
          <Label>Select fulfillment center</Label>
          <Input type='select' value={fulfillmentCenterId} onChange={onChangeFulfillmentCenter}>
            <option value=''>Select fulfillment center</option>
            {fulfillmentCenters.map((role) => (
              <option key={role.id} value={role.id}>
                {role.name}
              </option>
            ))}
          </Input>
        </div>
        <div className='col-3 form-group mb-0'>
          <Label>Date Range</Label>
          <div style={{ padding: '7px', border: '1px solid #979797' }}>
            <TopBarDatePicker start={start} end={end} onSubmit={onChangeDate} />
          </div>
        </div>
        <div className='col-2 form-group mb-0'>
          <Label>Order Number</Label>
          <Input value={orderNumber} onChange={(e) => setOrderNumber(e.target.value)} />
        </div>
        <div className='col-2 form-group mb-0'>
          <Label>Order ID</Label>
          <Input value={orderId} onChange={(e) => setOrderId(e.target.value)} />
        </div>
        <div className='col-2 text-center d-flex align-items-end justify-content-center'>
          <Button disabled={!isChanged} type='button' color='link' className='me-4' onClick={resetValues}>
            Reset
          </Button>{' '}
          <Button disabled={!isChanged} type='submit' color='primary' className='btn--rounded-padded'>
            Filter
          </Button>
        </div>
      </div>
    </Form>
  );
};
